import { render, staticRenderFns } from "./singlePrint.vue?vue&type=template&id=2c6483b2&scoped=true"
import script from "./singlePrint.vue?vue&type=script&lang=js"
export * from "./singlePrint.vue?vue&type=script&lang=js"
import style0 from "./singlePrint.vue?vue&type=style&index=0&id=2c6483b2&prod&lang=stylus"
import style1 from "./singlePrint.vue?vue&type=style&index=1&id=2c6483b2&prod&lang=stylus"
import style2 from "./singlePrint.vue?vue&type=style&index=2&id=2c6483b2&prod&lang=stylus&scoped=true"
import style3 from "./singlePrint.vue?vue&type=style&index=3&id=2c6483b2&prod&scoped=true&media=print&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6483b2",
  null
  
)

export default component.exports